import ApiBase from "../api-base";


export default class GrantsApi extends ApiBase {

    async getGrants(page = 1, perPage = 10, params = {}) {
        const response = await this.get('/grants', Object.assign({},{page : page, per_page : perPage}, params));
        return response.data;
    }

    async getGrant(id) {
        const response = await this.get('/grants/' + id);
        return response.data;
    }
}

